export default "__VITE_ASSET__Z9LSsyS4__"